<!-- @format -->

<div class="skeleton-fulfillment-container">
	<div class="skeleton-fulfillment-section hmf-p-xs hmf-p-sm-s">
		<span class="hmf-body-s">Fulfillment</span>

		<div class="fulfillment-row hmf-display-flex hmf-mt-xxs hmf-mb-xxs hmf-pb-xxs hmf-pb-sm-0">
			<div
				class="gradient-icon skeleton-grey-loading-animation hmf-align-self-center hmf-mr-xxxs"></div>
			<div class="fulfillment-placeholder skeleton-grey-loading-animation"></div>
		</div>

		<div class="fulfillment-row hmf-display-flex hmf-pb-xs hmf-pb-sm-0">
			<div
				class="gradient-icon skeleton-grey-loading-animation hmf-align-self-center hmf-mr-xxxs"></div>
			<div class="fulfillment-placeholder skeleton-grey-loading-animation"></div>
		</div>
	</div>
</div>
